import Layout from "@/components/feature/Layout";
import useSeo from "@/hooks/useSeo";
import Hero from "./components/Hero";
import CategoryNav from "./components/CategoryNav";
import NewReleases from "./components/NewReleases";
import RankingPreview from "./components/RankingPreview";
import MovieOva from "./components/MovieOva";
import Brand from "./components/Brand";
import Faq from "./components/Faq";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "漫番志会收录哪些类型的动漫？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "漫番志是一站式卡通动漫综合门户，覆盖新番、剧场版、OVA与经典番剧，并按热血、治愈、科幻、冒险、校园、奇幻、恋爱、悬疑等分类整理。",
      },
    },
    {
      "@type": "Question",
      name: "热门排行是怎么计算出来的？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "榜单综合了作品评分、追番热度与近期讨论度等指标，提供综合榜、新番榜、剧场版榜、OVA榜与经典榜等多个维度。",
      },
    },
    {
      "@type": "Question",
      name: "剧场版和 OVA 有什么区别？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "剧场版通常指在影院上映的动画电影，片长较长、制作规模大；OVA则指以光盘或网络发布的特别篇，篇幅短小但往往内容高能。",
      },
    },
  ],
};

export default function Home() {
  useSeo({
    title: "漫番志 - 卡通动漫综合分类，新番剧场版OVA热门排行导航",
    description:
      "漫番志是卡通动漫综合门户，新番速递、剧场版、OVA、经典番剧按类整理，热门排行实时更新，帮你快速定位当下值得追的作品。",
    keywords: "卡通动漫综合,动漫分类,新番速递,剧场版,OVA,热门排行,追番",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "漫番志",
        url: "https://freshanime.github.io/",
        description: "一站式卡通动漫综合分类门户，新番、剧场版、OVA、热门排行导航。",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "漫番志",
        url: "https://freshanime.github.io/",
        sameAs: [],
      },
      faqLd,
    ],
  });

  return (
    <Layout>
      <Hero />
      <CategoryNav />
      <NewReleases />
      <RankingPreview />
      <MovieOva />
      <Brand />
      <Faq />
    </Layout>
  );
}